<div id="page">
  <nav class="fh5co-nav" role="navigation"
    style="background-color:rgba(0, 0, 0, 0.85); color: rgba(255, 255, 255, 0.6); ">
    <div class="fh5co-nav">
      <div class="top" style="padding:0px auto;">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 text-center" style="text-align: center;">
              <ul class="fh5co-social" style="list-style: none; display: inline-block;">
                <li class="active" style="display: inline;"><a href="https://www.facebook.com/SourceCode.tw/"><i
                      class="icon-facebook2"
                      style=" color: rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
                <li class="active" style="display: inline;"><a href="https://www.linkedin.com/company/sourcecodetw/"><i
                      class="icon-linkedin2"
                      style=" color: rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
                <li class="active" style="display: inline;"><a [routerLink]="['/index']"><i class="icon-home-outline"
                      style=" color: rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
                <li class="active" style="display: inline;"><a [routerLink]="['/message']"><i class="icon-message"
                      style=" color:rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-xs-6 text-left">
          <div id="fh5co-logo"><a [routerLink]="['/index']" class="navbar-brand mr-lg-5"
              style=" color: #ffffff; font-size: 20px;">原碼後台管理</a></div>
        </div>
        <div class="col-xs-6 text-right menu-1">
          <ul>
            <li class="btn-cta"><a href="https://www.sourcecode.tw/SourceCode/#/home"><span>返回原碼</span></a></li>
            <li class="btn-cta"><a [routerLink]="['/message']"><span>聯絡我們</span></a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <aside id=" ">
    <div class="flexslider" style="margin-bottom: 5%;">
      <ul class="slides" style="padding-left: 0px !important; ">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
          <li ngxSlickItem class="slide"
            style="background-image: linear-gradient(rgba(0,0,0,0.2),rgba(0,0,0,0.3)),url(assets/images/banner_1.jpg) ; background-repeat:no-repeat;margin:0px;">
            <div class="overlay-gradient"></div>
            <div class="container">
              <div class="row">
                <div class="col-md-8 col-md-offset-2 text-center">
                  <div class="" style="margin-top: 35vh;">
                    <h1 class="car-h1">原碼後台管理最懂您要什麼</h1>
                    <h2 class="car-h2">您不需要一個功能繁雜的系統 <br />因此，原碼後台管理是您的最佳選擇<br /> <a href="http://freehtml5.co/"
                        target="_blank"></a></h2>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li ngxSlickItem class="slide"
            style="background-image: linear-gradient(rgba(0,0,0,0.2),rgba(0,0,0,0.3)),url(assets/images/banner_2.jpg) ; background-repeat:no-repeat;margin:0px;">
            <div class="overlay-gradient"></div>
            <div class="container">
              <div class="row">
                <div class="col-md-8 col-md-offset-2 text-center">
                  <div class="" style="margin-top: 35vh;">
                    <h1 class="car-h1">透過後台管理 讓您事半功倍</h1>
                    <h2 class="car-h2">原碼後台管理提供最高效的功能 讓管理網站與APP變得輕鬆便利<a href="http://freehtml5.co/" target="_blank"></a>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li ngxSlickItem class="slide"
            style="background-image: linear-gradient(rgba(0,0,0,0.2),rgba(0,0,0,0.3)),url(assets/images/banner_3.jpg) ; background-repeat:no-repeat;margin:0px;">
            <div class="overlay-gradient"></div>
            <div class="container">
              <div class="row">
                <div class="col-md-8 col-md-offset-2 text-center">
                  <div class="" style="margin-top: 35vh;">
                    <h1 style="color: #ffffff; font-size: 40px; margin-bottom: 3%;">不要猶豫，立即體驗</h1>
                    <h2 style="color: #ffffff; font-size: 20px; line-height: 30px;">原碼提供您免費試用服務，提供完善的試用體驗是我們的堅持<br /> <a
                        href="http://freehtml5.co/" target="_blank"></a></h2>
                    <p><a [routerLink]="['/message']"class="btn btn-primary btn-lg btn-learn" href="#"
                        style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; height: auto; font-weight: 600; letter-spacing:2px; padding:5%;" >立即免費體驗</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>

        </ngx-slick-carousel>
      </ul>
    </div>
  </aside>
  <div id="fh5co-course">
    <div class="container">
      <div class="row wow fadeInUp">
        <div class="col-md-6 col-md-offset-3 text-center fh5co-heading">
          <h2>原碼後台管理特色</h2>
          <p>最受青睞的功能 缺一不可</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 wow fadeInUp">
          <div class="course">
            <a href="#" class="course-img" style="background-image: url(./assets/images/img_1-01.jpg);">
            </a>
            <div class="desc">
              <h3><a href="#">即時數據分析及分析圖表</a></h3>
              <p>原碼後台管理提供即時前端數據資料分析，透過各種圖表呈現，讓您要的分析結果一目瞭然</p>

            </div>
          </div>
        </div>
        <div class="col-md-6 wow fadeInUp">
          <div class="course">
            <a href="#" class="course-img" style="background-image: url(./assets/images/img_2-01.jpg);">
            </a>
            <div class="desc">
              <h3><a href="#">提供您獨一無二使用體驗</a></h3>
              <p>原碼後台管理提供客製化介面，搭配企業形象Logo及配色<br> </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 wow fadeInUp">
          <div class="course">
            <a href="#" class="course-img" style="background-image: url(assets/images/project-3.jpg);">
            </a>
          </div>
        </div>
        <div class="col-md-6 wow fadeInUp">
          <div class="course">
            <a href="#" class="course-img" style="background-image: url(assets/images/project-4.jpg);">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="fh5co-course-categories">
    <div class="container">
      <div class="row wow fadeInUp">
        <div class="col-md-6 col-md-offset-3 text-center fh5co-heading">
          <h2>原碼後台管理功能簡介</h2>
          <p>原碼後台管理將使用者最需要的功能匯聚在一起</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/1_dashboard.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">多種數據圖表呈現</a></h3>
              <p>圓餅圖、長條圖、折線圖<br>等圖表呈現統計資料 </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/2_statistics.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">數據分析</a></h3>
              <p>根據前台資料進行快速數據分析</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/3_authorization.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">權限設定</a></h3>
              <p>權限、角色及帳號可根據不同的登入<br>操作不同的功能模組</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/4_information-management.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">根據前台需求動態修改資料</a></h3>
              <p>即時修改前台內容<br>方便隨時管理網站<br> </p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/5_team-management.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">管理者權限管理</a></h3>
              <p>總管理者能設定各個管理員的權限<br>限制每個管理員能看見的單元</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/6_website.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">客製化介面</a></h3>
              <p>配合客戶進行客製化配色介面</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/7_data.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">客製化資料型態需求</a></h3>
              <p>配合客戶網站種類調整數據格式設定</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 text-center wow fadeInUp">
          <div class="services">
            <span class="icon">
              <img src="./assets/icon/8_secret-file.svg" style="transform: scale(0.5);">
            </span>
            <div class="desc">
              <h3><a href="#">資安保障</a></h3>
              <p>嚴格保障後台資料安全</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="fh5co-counter" class="fh5co-counters"
    style="background-image: url(./assets/images/banner_4.jpg); height: 70vh;" data-stellar-background-ratio="0.5">
    <div class="overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="row">
          </div>
        </div>
      </div>
    </div>
  </div>





  <footer id="fh5co-footer" role="contentinfo" style="background-image: url(assets/images/img_bg_4.jpg);">
    <div class="overlay"></div>
    <div class="container">
      <div class="row copyright">
        <div class="col-md-12 text-center">
          <p>
            <small class="block">&copy; 2020 原碼數位科技有限公司</small>
            <small class="block">新北市中和區建八路2號4樓之7&nbsp;&nbsp;<a href="tel:02-8228-0407">(02)8228-0407</a></small>
          </p>
        </div>
      </div>
    </div>
  </footer>
</div>

<div class="gototop js-top">
  <a href="#" class="js-gotop"><i class="icon-arrow-up"></i></a>
</div>
